import cloneDeep from 'lodash.clonedeep';
import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const contactTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Contact',
  key: 'contact',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'name',
            'email',
            'phone'
          ],
          [
            'fullname',
            'organization',
            'pager'
          ],
          [
            'mobile',
            'fax',
            'address'
          ]
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      name: {
        label: 'Nickname',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        },
      },
      email: {
        label: 'E-mail Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'EMAIL',
              errorMessage: 'Please enter a valid email address.',
            },
          ],
        },
      },
      phone: {
        label: 'Phone Number',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'regexp',
              regexp: '^[0-9]*$',
              errorMessage: 'Please enter a valid phone number.'
            },
            {
              type: 'length',
              length: 15,
              errorMessage: 'Exceeds maximum length, 15.  Please re-enter.'
            }
          ],
        },
      },
      dxOwner: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      dxAccess: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      fullname: {
        label: 'Full Name',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 24,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        }
      },
      organization: {
        label: 'Organization',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 24,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        }
      },
      pager: {
        label: 'Pager',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 20,
            }
          ],
        }
      },
      mobile: {
        label: 'Mobile',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        }
      },
      fax: {
        label: 'Fax',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        }
      },
      address: {
        label: 'Address',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 48,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces'],
              errorMessage: 'Can include letters, digits. Please re-enter.',
            },
          ],
        }
      },
    },
  },
};

export const adpatedDialogTemplate = () => {
  const clonedTemplate = cloneDeep(contactTemplate)

  if (!clonedTemplate.main) {
    return clonedTemplate;
  }

  clonedTemplate.main.metadata = {
    layout: {
      rows: [
        [
          'name',
        ],
        [
          'email',
        ],
        [
          'phone',
        ],
      ],
    },
  }

  return clonedTemplate;
}
